// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Inter-Regular400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/Inter-Medium500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/Inter-SemiBold600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/Inter-Bold700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/key-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
.Auth_wrapper__oBPRq {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: grid;
  justify-items: center;
}
@media (max-width: 700px) {
  .Auth_wrapper__oBPRq {
    grid-template-rows: auto min-content;
  }
}

.Auth_codeword__NlwCV {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.Auth_confirm_email__msg__Ob6Db,
.Auth_reset_password__msg__Qlgyd {
  background: #1ab39447;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-radius: 12px !important;
}

.Auth_confirm_email__msg_error__gMJQ6,
.Auth_reset_password__msg_error__tYciN {
  background: #f1080852;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-radius: 12px !important;
}

.Auth_new_account_wrapper__WFWWd {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 700px) {
  .Auth_new_account_wrapper__WFWWd {
    gap: 5px;
    font-size: 14px;
  }
}
.Auth_new_account_wrapperspan__Kc0uK {
  color: #616E6E;
}
.Auth_new_account_wrappera__9Lh\\+h {
  color: #1DB5B6 !important;
}

.Auth_forgot_link__hUPil {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1DB5B6;
  display: flex;
  gap: 9px;
  margin-bottom: 18px;
}
.Auth_forgot_link__hUPil:before {
  content: "";
  padding-left: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  margin-top: 1px;
}
.Auth_forgot_link__hUPil:hover {
  color: #1DB5B6 !important;
}

.Auth_register_link__41i9S {
  color: #1DB5B6;
}
.Auth_register_link__41i9S:hover {
  color: #1DB5B6 !important;
}

.Auth_box_wrapper__lbevf, .Auth_box_wrapper_confirm__Thzqz {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: flex-end;
}
.Auth_box_wrapper_confirm__Thzqz {
  justify-content: center !important;
  max-width: 360px !important;
}
@media (max-width: 700px) {
  .Auth_box_wrapper__lbevf, .Auth_box_wrapper_confirm__Thzqz {
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    max-width: 100%;
  }
}
.Auth_box_container__W3mAk {
  padding: 12px 30px 25px 30px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}
@media (max-width: 700px) {
  .Auth_box_container__W3mAk {
    padding: 27px 25px 27px 25px;
    margin: 0 auto;
    max-width: 360px;
  }
}
.Auth_box_container__W3mAk.Auth_mb-3__TXCUg {
  margin-bottom: 12px !important;
}
@media (max-width: 700px) {
  .Auth_box_container__W3mAk.Auth_mb-3__TXCUg {
    margin-bottom: 20px !important;
    max-width: 360px;
  }
}

.Auth_title__ZiKhr {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 50px;
  color: #080808;
  margin: 0 !important;
  text-align: left !important;
}
@media (max-width: 700px) {
  .Auth_title__ZiKhr {
    font-size: 20px;
    line-height: 30px;
  }
}
.Auth_title_container__G3tFl {
  margin-bottom: 17px;
}

.Auth_owner__oONIE {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 40px;
  box-sizing: content-box;
  padding-top: 20px;
}
@media (max-width: 700px) {
  .Auth_owner__oONIE {
    flex-direction: row;
    margin: 25px 0 25px 24px;
    width: 100%;
    justify-content: flex-start;
  }
}
.Auth_owner_name__ntxF6 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #bdbcbc;
}

@media (max-width: 700px) {
  .Auth_logo__\\+Z1HK {
    margin: 22px 0 0 12px;
    width: 100%;
  }
}

.Auth_agree__qu6kU, .Auth_agree_link__vrXse {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 19px;
  color: #899696;
}
.Auth_agree_link__vrXse {
  text-decoration: underline;
}

.Auth_confirm_title__5mfdG {
  color: #080808;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 50px;
  margin: 0 !important;
  text-align: left !important;
}

.Auth_reset_sent__z\\+acL {
  justify-content: center;
}

@media (max-width: 700px) {
  .Auth_reset_title__3kaN9 {
    padding-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/vendors/fonts.scss","webpack://./src/components/Auth/Auth.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACFF;AAxBA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AA0BF;AAxBE;EAPF;IAQI,oCAAA;EA2BF;AACF;;AAxBA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AA2BF;;AAxBA;;EAEE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AA2BF;;AAxBA;;EAEE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AA2BF;;AAxBA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AA2BF;AAzBE;EATF;IAUI,QAAA;IACA,eAAA;EA4BF;AACF;AA1BE;EACE,cAAA;AA4BJ;AAzBE;EACE,yBAAA;AA2BJ;;AAtBA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAyBF;AAvBE;EACE,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;AAyBJ;AAtBE;EACE,yBAAA;AAwBJ;;AApBA;EACE,cAAA;AAuBF;AArBE;EACE,yBAAA;AAuBJ;;AAlBE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;AAqBJ;AAnBI;EAEE,kCAAA;EACA,2BAAA;AAoBN;AAjBI;EAdF;IAeI,8BAAA;IACA,YAAA;IACA,sBAAA;IACA,eAAA;EAoBJ;AACF;AAhBE;EACE,4BAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;AAkBJ;AAhBI;EANF;IAOI,4BAAA;IACA,cAAA;IACA,gBAAA;EAmBJ;AACF;AAjBI;EACE,8BAAA;AAmBN;AAjBM;EAHF;IAII,8BAAA;IACA,gBAAA;EAoBN;AACF;;AAfA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,2BAAA;AAkBF;AAhBE;EAVF;IAWI,eAAA;IACA,iBAAA;EAmBF;AACF;AAjBE;EACE,mBAAA;AAmBJ;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAkBF;AAhBE;EAVF;IAWI,mBAAA;IACA,wBAAA;IACA,WAAA;IACA,2BAAA;EAmBF;AACF;AAjBE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAmBJ;;AAdE;EADF;IAEI,qBAAA;IACA,WAAA;EAkBF;AACF;;AAfA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAkBF;AAhBE;EAEE,0BAAA;AAiBJ;;AAbA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;AAgBF;;AAbA;EACE,uBAAA;AAgBF;;AAZE;EADF;IAEI,oBAAA;EAgBF;AACF","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Regular400.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Medium500.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-SemiBold600.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Bold700.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}","@import \"../../styles/vendors/mixins\";\n@import \"../../styles/vendors/fonts\";\n\n.wrapper {\n  width: 100%;\n  min-height: 100vh;\n  height: 100%;\n  display: grid;\n  justify-items: center;\n\n  @media (max-width: 700px) {\n    grid-template-rows: auto min-content;\n  }\n}\n\n.codeword {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.confirm_email__msg,\n.reset_password__msg {\n  background: #1ab39447;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  border-radius: 12px !important;\n}\n\n.confirm_email__msg_error,\n.reset_password__msg_error {\n  background: #f1080852;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  border-radius: 12px !important;\n}\n\n.new_account_wrapper {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 700px) {\n    gap: 5px;\n    font-size: 14px;\n  }\n\n  &span {\n    color: #616E6E;\n  }\n\n  &a {\n    color: #1DB5B6 !important;\n  }\n\n}\n\n.forgot_link {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #1DB5B6;\n  display: flex;\n  gap: 9px;\n  margin-bottom: 18px;\n\n  &:before {\n    content: '';\n    padding-left: 15px;\n    background-image: url('../../images/key-icon.svg');\n    background-repeat: no-repeat;\n    margin-top: 1px;\n  }\n\n  &:hover {\n    color: #1DB5B6 !important;\n  }\n}\n\n.register_link {\n  color: #1DB5B6;\n\n  &:hover {\n    color: #1DB5B6 !important;\n  }\n}\n\n.box {\n  &_wrapper {\n    width: 100%;\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    justify-content: flex-end;\n\n    &_confirm {\n      @extend .box_wrapper;\n      justify-content: center !important;\n      max-width: 360px !important;\n    }\n\n    @media(max-width: 700px) {\n      justify-content: space-between;\n      height: 100%;\n      box-sizing: border-box;\n      max-width: 100%;\n    }\n\n  }\n\n  &_container {\n    padding: 12px 30px 25px 30px;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);\n    border-radius: 10px;\n\n    @media(max-width: 700px) {\n      padding: 27px 25px 27px 25px;\n      margin: 0 auto;\n      max-width: 360px;\n    }\n\n    &.mb-3 {\n      margin-bottom: 12px !important;\n\n      @media(max-width: 700px) {\n        margin-bottom: 20px !important;\n        max-width: 360px;\n      }\n    }\n  }\n}\n\n.title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 50px;\n  color: #080808;\n  margin: 0 !important;\n  text-align: left !important;\n\n  @media(max-width: 700px) {\n    font-size: 20px;\n    line-height: 30px;\n  }\n\n  &_container {\n    margin-bottom: 17px;\n  }\n}\n\n.owner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-bottom: 40px;\n  box-sizing: content-box;\n  padding-top: 20px;\n\n  @media(max-width: 700px) {\n    flex-direction: row;\n    margin: 25px 0 25px 24px;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  &_name {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 20px;\n    color: #bdbcbc;\n  }\n}\n\n.logo {\n  @media(max-width: 700px) {\n    margin: 22px 0 0 12px;\n    width: 100%;\n  }\n}\n\n.agree {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 19px;\n  color: #899696;\n\n  &_link {\n    @extend .agree;\n    text-decoration: underline;\n  }\n}\n\n.confirm_title {\n  color: #080808;\n  font-family: Inter;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 50px;\n  margin: 0 !important;\n  text-align: left !important;\n}\n\n.reset_sent {\n  justify-content: center;\n}\n\n.reset_title {\n  @media(max-width: 700px) {\n    padding-bottom: 10px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Auth_wrapper__oBPRq`,
	"codeword": `Auth_codeword__NlwCV`,
	"confirm_email__msg": `Auth_confirm_email__msg__Ob6Db`,
	"reset_password__msg": `Auth_reset_password__msg__Qlgyd`,
	"confirm_email__msg_error": `Auth_confirm_email__msg_error__gMJQ6`,
	"reset_password__msg_error": `Auth_reset_password__msg_error__tYciN`,
	"new_account_wrapper": `Auth_new_account_wrapper__WFWWd`,
	"new_account_wrapperspan": `Auth_new_account_wrapperspan__Kc0uK`,
	"new_account_wrappera": `Auth_new_account_wrappera__9Lh+h`,
	"forgot_link": `Auth_forgot_link__hUPil`,
	"register_link": `Auth_register_link__41i9S`,
	"box_wrapper": `Auth_box_wrapper__lbevf`,
	"box_wrapper_confirm": `Auth_box_wrapper_confirm__Thzqz`,
	"box_container": `Auth_box_container__W3mAk`,
	"mb-3": `Auth_mb-3__TXCUg`,
	"title": `Auth_title__ZiKhr`,
	"title_container": `Auth_title_container__G3tFl`,
	"owner": `Auth_owner__oONIE`,
	"owner_name": `Auth_owner_name__ntxF6`,
	"logo": `Auth_logo__+Z1HK`,
	"agree": `Auth_agree__qu6kU`,
	"agree_link": `Auth_agree_link__vrXse`,
	"confirm_title": `Auth_confirm_title__5mfdG`,
	"reset_sent": `Auth_reset_sent__z+acL`,
	"reset_title": `Auth_reset_title__3kaN9`
};
export default ___CSS_LOADER_EXPORT___;
